module.exports = __webpack_public_path__ + "img/offline.3ea532d2.svg";